
(function () {
  'use strict';

  var panel = document.querySelector('[data-filter-panel]');
  if (!panel) return;

  var opener = document.querySelector('[data-filter-open]');
  var scrim = document.querySelector('[data-filter-scrim]');
  var form = panel.querySelector('[data-filters-form]');
  var applyBtn = panel.querySelector('[data-filters-apply]');

  var mq = window.matchMedia('(max-width: 1023px)');

  var openState = false;
  var lastFocus = null;
  var inertTimer = null;

  function isOpen() { return openState; }

  function lock() {
    if (window.TwoLaneA11y && window.TwoLaneA11y.lockScroll) window.TwoLaneA11y.lockScroll();
  }
  function unlock() {
    if (window.TwoLaneA11y && window.TwoLaneA11y.unlockScroll) window.TwoLaneA11y.unlockScroll();
  }

  function setInert(on) {
    if (on) panel.setAttribute('inert', '');
    else panel.removeAttribute('inert');
  }

  function clearInertTimer() {
    if (inertTimer) { clearTimeout(inertTimer); inertTimer = null; }
  }

  function countSelected() {
    if (!form) return 0;
    var n = 0;
    var boxes = form.querySelectorAll('input[type="checkbox"]');
    Array.prototype.forEach.call(boxes, function (box) { if (box.checked) n++; });
    var priced = false;
    var numbers = form.querySelectorAll('.filter-group__price input[type="number"]');
    Array.prototype.forEach.call(numbers, function (input) {
      if (input.value !== '') priced = true;
    });
    if (priced) n++;
    return n;
  }

  function updateApplyLabel() {
    if (!applyBtn) return;
    var base = applyBtn.getAttribute('data-apply-label') || applyBtn.textContent;
    var n = countSelected();
    var suffix = n > 0 ? window.t('filters_apply_count', ' (__COUNT__)', { COUNT: n }) : '';
    applyBtn.textContent = base + suffix;
  }

  function open() {
    if (openState || !mq.matches) return;
    openState = true;
    clearInertTimer();
    lastFocus = document.activeElement;

    setInert(false);

    if (scrim) scrim.classList.add('is-open');
    panel.classList.add('is-open');

    if (opener) opener.setAttribute('aria-expanded', 'true');

    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');

    lock();
    updateApplyLabel();

    if (window.TwoLaneA11y) window.TwoLaneA11y.focusFirst(panel, '[data-filter-close]');
  }

  function close() {
    if (!openState) return;
    openState = false;

    panel.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');

    unlock();

    if (window.TwoLaneA11y) window.TwoLaneA11y.restore(lastFocus);
    lastFocus = null;

    clearInertTimer();
    inertTimer = setTimeout(function () {
      inertTimer = null;
      if (mq.matches && !openState) setInert(true);
    }, 400);
  }

  function syncMode() {
    if (mq.matches) {
      if (!openState) setInert(true);
      return;
    }
    if (openState) close();
    clearInertTimer();
    setInert(false);
    panel.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    if (opener) opener.setAttribute('aria-expanded', 'false');
  }

  if (mq.addEventListener) mq.addEventListener('change', syncMode);
  else mq.addListener(syncMode);
  syncMode();

  if (opener) opener.addEventListener('click', open);
  if (scrim) scrim.addEventListener('click', close);

  panel.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-filter-close]')) { close(); return; }

    var more = target.closest('[data-filter-more]');
    if (more) {
      var list = more.closest('[data-filter-list]');
      if (!list) return;
      var expanded = more.getAttribute('aria-expanded') === 'true';
      var extras = list.querySelectorAll('[data-filter-extra]');
      Array.prototype.forEach.call(extras, function (row) {
        if (expanded) row.setAttribute('hidden', '');
        else row.removeAttribute('hidden');
      });
      more.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      more.textContent = expanded
        ? window.t('filters_show_more', 'Show all')
        : window.t('filters_show_less', 'Show fewer');
    }
  });

  function foldCase(str) {
    var s = String(str || '').toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/\s+/g, ' ').trim();
  }

  function filterBrands(input) {
    var group = input.closest('[data-brand-group]');
    var list = group && group.querySelector('[data-brand-list]');
    if (!list) return;

    var query = foldCase(input.value);
    var more = list.querySelector('[data-filter-more]');
    var moreRow = more ? more.closest('li') : null;
    var expanded = !more || more.getAttribute('aria-expanded') === 'true';
    var matches = 0;

    Array.prototype.forEach.call(group.querySelectorAll('[data-brand-subhead]'), function (head) {
      if (query === '') head.removeAttribute('hidden');
      else head.setAttribute('hidden', '');
    });
    Array.prototype.forEach.call(group.querySelectorAll('[data-brand-row]'), function (row) {
      var show = query === ''
        ? (expanded || !row.hasAttribute('data-filter-extra'))
        : foldCase(row.getAttribute('data-brand-label')).indexOf(query) !== -1;
      if (show) {
        row.removeAttribute('hidden');
        matches++;
      } else {
        row.setAttribute('hidden', '');
      }
    });

    if (moreRow) {
      if (query === '') moreRow.removeAttribute('hidden');
      else moreRow.setAttribute('hidden', '');
    }

    Array.prototype.forEach.call(group.querySelectorAll('[data-brand-top-list]'), function (topList) {
      var anyShown = topList.querySelector('[data-brand-row]:not([hidden])');
      if (query !== '' && !anyShown) topList.setAttribute('hidden', '');
      else topList.removeAttribute('hidden');
    });

    var empty = group.querySelector('[data-brand-empty]');
    if (empty) {
      var text = query !== '' && matches === 0 ? window.t('brand_no_results', 'No brands match') : '';
      if (empty.textContent !== text) empty.textContent = text;
    }
  }

  panel.addEventListener('input', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('[data-brand-search]')) filterBrands(el);
  });

  panel.addEventListener('keydown', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('[data-brand-search]')) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      return;
    }

    if (e.key === 'Escape' && el.value !== '') {
      e.preventDefault();
      e.stopPropagation();
      el.value = '';
      filterBrands(el);
    }
  });

  Array.prototype.forEach.call(panel.querySelectorAll('[data-brand-search]'), function (el) {
    if (el.value) filterBrands(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !openState) return;
    e.stopPropagation();
    close();
  });

  if (window.TwoLaneA11y) {
    document.addEventListener('keydown', window.TwoLaneA11y.trap(panel, isOpen));
  }

  function submitForm() {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  if (form) {
    var RAIL_KEY = '2lane:rail-scroll';
    var RAIL_STICKS_AT = 160;
    var lastTicked = null;

    function offsetInRail(el) {
      return el.getBoundingClientRect().top - panel.getBoundingClientRect().top;
    }

    try {
      var rail = JSON.parse(sessionStorage.getItem(RAIL_KEY));
      sessionStorage.removeItem(RAIL_KEY);
      if (rail && typeof rail === 'object' && !mq.matches &&
          rail.path === window.location.pathname &&
          Date.now() - Number(rail.at) < 10000) {
        var anchor = null;
        if (rail.name) {
          Array.prototype.forEach.call(form.elements, function (el) {
            if (!anchor && el.name === rail.name && el.value === rail.value) anchor = el;
          });
        }
        var placed = anchor && anchor.getClientRects().length > 0;
        if (placed) panel.scrollTop += offsetInRail(anchor) - rail.offset;
        else panel.scrollTop = rail.top;
        var below = placed && anchor.getBoundingClientRect().bottom > window.innerHeight;
        if (panel.scrollTop > 0 || below) {
          var stick = panel.getBoundingClientRect().top + window.pageYOffset - RAIL_STICKS_AT;
          if (stick > window.pageYOffset) {
            var root = document.documentElement;
            var smooth = root.style.scrollBehavior;
            root.style.scrollBehavior = 'auto';
            window.scrollTo(0, stick);
            root.style.scrollBehavior = smooth;
          }
        }
      }
    } catch (e) { /* no storage: the rail starts at the top */ }
    form.addEventListener('submit', function () {
      if (mq.matches) return;
      try {
        sessionStorage.setItem(RAIL_KEY, JSON.stringify({
          top: panel.scrollTop,
          name: lastTicked ? lastTicked.name : '',
          value: lastTicked ? lastTicked.value : '',
          offset: lastTicked ? offsetInRail(lastTicked) : 0,
          path: window.location.pathname,
          at: Date.now()
        }));
      } catch (e) { /* ignore */ }
    });

    form.addEventListener('change', function (e) {
      var el = e.target;
      if (!el || el.type !== 'checkbox') return;
      updateApplyLabel();
      if (mq.matches) return;
      lastTicked = el;
      submitForm();
    });

    form.addEventListener('input', function (e) {
      if (!e.target || e.target.type !== 'number') return;
      updateApplyLabel();
    });
  }

  updateApplyLabel();

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    close();
    if (form) {
      Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"]'), function (box) {
        box.checked = box.defaultChecked;
      });
      Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (field) {
        field.value = field.defaultValue;
      });
      updateApplyLabel();
    }
  });
})();
